<template>
  <div class='container'>
    <!-- 介绍 -->
    <div class="introduce">猜你想问</div>
    <!-- 问题 -->
    <div class="query_type">
      <!-- 问题类型每项 -->
      <div class="new_transact clearfix have_height"
        v-for="(item,index) in issueData" :key='index'
        :class="{ 'not_height':activate.indexOf(index) != -1 }"
      >

        <div class="left" @click="onClick(index)">
          <img src="https://static.etcmall.cn/etcissue/trucking/problem.png" alt="">
          <span>{{item.name}}</span>
          <i class="cubeic-pulldown" :class="{ 'cubeic-pullup':activate.indexOf(index) != -1 }" ></i>
        </div>

        <div class="right">
          <!-- @click="toDetails(index)" -->
          <span class="above" v-for="(issueItem,index) in item.subList" :key="index">{{issueItem.problemText}}</span>
        </div>
      </div>
    </div>

    <div class="blank"></div>

    <div class="news" v-if="show">
      <div class="left">
        <img src="https://static.etcmall.cn/etcissue/trucking/newMes.png" alt="">
        <span>新消息</span>
      </div>
      <div class="right">
        <span>尊敬的用户，您暂时没有新的消息反馈。</span>
      </div>
    </div>
    <!-- 在线咨询 -->
    <div class="line-consult">
      <span>以上问题都不是，我要在线咨询</span>
      <img src="https://static.etcmall.cn/etcissue/trucking/onLine_service.png" alt="">
    </div>
  </div>
</template>

<script>
import { axios } from "../../util/request";
export default {
  data() {
    return {
      issueData: [],
      userId: sessionStorage.getItem("USER-ID"),
      show: false,
      // issueData: [
      //   {
      //     id:0,
      //     category:'新办',
      //     data:[
      //       {title: '为什么还有很多银行未覆盖？'},
      //       {title: '如何申请货车ETC？'},
      //     ]
      //   },
      //   {
      //     id:1,
      //     category:'安装激活',
      //     data:[
      //       {title: '车辆已经安装过ETC，还可以再办理吗？'},
      //       {title: 'ETC安装到玻璃上，现在要更换玻璃，需要怎么操作呢？'},
      //       {title: 'ETC安装到玻璃上，现在要更换玻璃，需要怎么操作呢？'},
      //     ]
      //   },
      //   {
      //     id:2,
      //     category:'售后',
      //     data:[
      //       {title: '如何查询扣费问题？'},
      //       {title: '通行记录账单如何查询？'},
      //       {title: '通行记录账单如何查询？'},
      //     ]
      //   },
      //   {
      //     id:3,
      //     category:'常见问题',
      //     data:[
      //       {title: '货车如何预约通行？'},
      //       {title: '绿通车如何退费？'},
      //       {title: '绿通车如何退费？'},
      //     ]
      //   },
      // ],
      activate:[]
    }
  },
  methods: {
    onClick (index) {
      let indexItem = this.activate.indexOf(index);
        if( indexItem == -1 ){
          this.activate.push(index);
        }else{
          this.activate.splice(indexItem,1);
        }
        console.log(this.activate);
    },
    // toDetails(index) {
    //   this.$router.push({name: 'issueDetails',params:{index:index}});
    // },
    createDialog(title,content){
      this.$createDialog({
      type: 'alert',
      title: title,
      content: content,
      icon: 'cubeic-alert'
      }).show()
    },
    getUser() {
      if(this.userId) {
        this.show = true;
      }
    }
  },
  mounted() {
    this.getUser();
    axios.get('/FAQ/List').then(data=> {
      console.log(data);
      if(data.state == 1) {
        this.issueData = data.result;
        console.log(this.issueData);
      } else {
        this.createDialog("用户提示","暂无问题。");
      }
    })
  }
}

</script>
<style scoped lang='less'>
@import '../../assets/styles/varibles.less';
.container {
  height: 100%;
  width: 100%;
  padding-top: 2px;
  background-color: #fff;
  .introduce {
    width: 100%;
    height: 2.43rem;
    line-height: 2.43rem;
    text-align: left;
    font-size: 0.875rem;
    // color: #343434;
    // background: #efefef;
    background-color: @titleColor;
    color: #fff;
    text-indent: 0.875rem;
    font-weight: 500;
  }
  .query_type {
    width: 100%;
    height: 100%;
    background: #ffffff;
    .have_height {
      height: 5.86rem;
      overflow: hidden;
      .right {
        span:nth-child(2) {
          border-bottom: none;
        }
      }
    }
    .not_height {
      height: 100%;
      .right {
        span:nth-child(2) {
          border-bottom: 1px solid #dddddd;
        }
      }
    }
    .new_transact {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #dddddd;
      .left {
        display: inline-block;
        height: 100%;
        width: 5.06rem;
        font-size: 0.81rem;
        img {
          display: block;
          width: 1.75rem;
          height: 1.75rem;
          margin: 1rem auto 0;
        }
        span {
          display:block;
          margin-top: 0.4rem;
        }
        .cubeic-pulldown::before {
          font-size: 1.5rem;
        }
        .cubeic-pullup::before {
          font-size: 1.5rem;
        }
      }
      .right {
        display: inline-block;
        height: 100%;
        flex: 1;
        overflow: hidden;
        span:last-child {
          border-bottom: none;
        }
        .above {
          display: block;
          width: 100%;
          height: 2.93rem;
          line-height: 2.93rem;
          text-align: left;
          border-bottom: 1px solid #dddddd;
          border-left: 1px solid #dddddd;
          padding-left: 0.68rem;
          box-sizing: border-box;
          font-size: 0.68rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .blank {
    height: 0.625rem;
    width: 100%;
    background: #edf5f5;
  } 
  .news {
    height: 2.81rem;
    width: 100%;
    border-bottom: 1px solid #dddddd;
    background: #ffffff;
    .left {
      float: left;
      height: 100%;
      width: 5.06rem;
      font-size: 0.81rem;

      line-height: 2.81rem;
      img {
        margin-left: 0.6rem;
        width: 1.3rem;
        height: 1rem;
        margin-right: 0.625rem;
        // display: inline-block;
      }
    }
    .right {
      float: left;
      height: 100%;
      width: 18.3rem;
      line-height: 2.81rem;
      font-size: 0.81rem;
      text-align: left;
      text-indent: 0.68rem;
    }
  }
  .line-consult {
    height: 4.25rem;
    width: 100%;
    line-height: 4.25rem;
    background: #ffffff;
    padding-top: 1.25rem;
    padding-bottom: 4rem;
    span {
      text-indent: 5rem;
      font-size: 0.81rem;
      
    }
    img {
      height: 3rem;
      width: 3rem;
      display: inline-block;
      vertical-align:middle;
      margin-left: 0.625rem;
    }
  }
}
.clearfix:after{
      content: "";
      display: block;
      height: 0;
      clear:both;
      visibility: hidden;
  }
.clearfix{
    *zoom: 1;
}
.tavActive {
  background-color: pink;
}
</style>